import {Component, Input, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {CompanyResponse, UserEntityRelationWithUserDataResponse} from '../../../../@shared/models/response.module';
import {EndpointService} from '../../../../@shared/endpoints.service';
import {COR_COY_3, USM_ENT_2, USM_ENT_3} from '../../../../@shared/models/input.module';
import {InviteUserModal} from './components/invite-user-modal/invite-user-modal';
import {TranslateService} from '@ngx-translate/core';
import {ToastService} from '../../../../@core/services/toast.service';

@Component({
  selector: 'app-company-profile-users',
  standalone: false,
  templateUrl: './company-profile-users.html',
  styleUrl: './company-profile-users.css'
})
export class CompanyProfileUsers implements OnInit {
  @Input() company: CompanyResponse;
  @Input() userRole: number;

  users: UserEntityRelationWithUserDataResponse[] = [];
  loading: boolean = true;

  // Role options
  roleOptions: { role_id: number, role_name: string, description: string }[] = [];

  constructor(
    private endpointService: EndpointService,
    private modalService: NgbModal,
    private translateService: TranslateService,
    private toastService: ToastService
  ) {}

  private initRoleOptions() {
    this.roleOptions = [
      { role_id: 1, role_name: this.translateService.instant('companyProfile.users.roleAdmin'), description: 'Full access to all features' },
      { role_id: 2, role_name: this.translateService.instant('companyProfile.users.roleMember'), description: 'Basic access to organisation' }
    ];
  }

  ngOnInit() {
    console.log("UserRole", this.userRole)
    this.initRoleOptions();
    this.loadUsers();
  }

  loadUsers() {
    this.loading = true;
    const params: COR_COY_3 = {
      company_id: this.company.company_id
    };

    this.endpointService.cor_coy_3(params).subscribe({
      next: (res) => {
        this.users = res.data || [];
        this.loading = false;
      },
      error: () => {
        this.users = [];
        this.loading = false;
      }
    });
  }

  openInviteUserModal() {
    const modalRef = this.modalService.open(InviteUserModal, {
      size: 'lg',
      centered: true
    });
    modalRef.componentInstance.companyId = this.company.company_id;
    modalRef.componentInstance.existingUsers = this.users;

    modalRef.result.then(
      (result) => {
        if (result === 'added' || result === 'invited') {
          this.loadUsers();
        }
      },
      () => {}
    );
  }

  updateUserRole(user: UserEntityRelationWithUserDataResponse, newRoleId: number) {
    const params: USM_ENT_2 = {
      user_id: user.user_id,
      entity_id: this.company.company_id,
      role_id: newRoleId,
      component_id: user.component_access_id
    };

    this.endpointService.usm_ent_2(params).subscribe({
      next: () => {
        this.toastService.success(this.translateService.instant('companyProfile.users.roleUpdateSuccess'));
        this.loadUsers();
      },
      error: () => {
        this.toastService.error(this.translateService.instant('companyProfile.users.roleUpdateError'));
      }
    });
  }

  removeUser(user: UserEntityRelationWithUserDataResponse) {
    if (!confirm(this.translateService.instant('companyProfile.users.removeConfirm'))) {
      return;
    }

    const params: USM_ENT_3 = {
      user_id: user.user_id,
      entity_id: this.company.company_id
    };

    this.endpointService.usm_ent_3(params).subscribe({
      next: () => {
        this.toastService.success(this.translateService.instant('companyProfile.users.removeSuccess'));
        this.loadUsers();
      },
      error: () => {
        this.toastService.error(this.translateService.instant('companyProfile.users.removeError'));
      }
    });
  }

  getInitials(firstName: string | null, lastName: string | null): string {
    const first = firstName?.charAt(0)?.toUpperCase() || '';
    const last = lastName?.charAt(0)?.toUpperCase() || '';
    return first + last || '?';
  }

  isAdmin(): boolean {
    return this.userRole === 0 || this.userRole === 1;
  }
}
